import './App.css'
import Artifact from './pages/Recommender'

function FormView() {
  return (
    <>
      <Artifact />
    </>
  )
}

export default FormView
